<template>
  <div class="row no-gutters justify-content-md-center align-items-center" style="padding-bottom: 4px">
    <div class="col-4">
      <el-cascader 
        v-model="value.attribute"
        @change="$emit('changed', value)"
        :show-all-levels="false"
        :clearable="true"
        :props="selectorProps">
      </el-cascader>
    </div>
    <div class="col-2">
      <multiselect
        v-model="value.conditional"
        :options="conditionals"
        placeholder="Ex: >="
        :select-label="''"
        :deselect-label="''"
        :selected-label="'Selecionado'"
        label="name"
        track-by="value"
        @close="$emit('changed', value)"
        :show-labels="true"
        :allow-empty="false"
        :preselect-first="true">
      </multiselect>
    </div>
    <div class="col-6">
      <div class="row no-gutters">
        <div :class="`col-${value.type ? '7' : '12'}`">
          <multiselect
            v-model="value.type"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :options="valueOptions"
            placeholder="Selecione"
            label="name"
            track-by="value"
            @close="$emit('changed', value)"
            :show-labels="false"
            :preserveSearch="true" />

        </div>
        <div class="col-5" v-show="value.type">
          <base-input
            class="mb-3"
            style="height: 40px;"
            v-model="value.value"
            @input="$emit('changed', value)"
            v-if="value.type && ['text', 'number', 'days'].includes(value.type.value)"
            :type="['number', 'days'].includes(value.type.value) ? 'number' : 'text'"
            wrapperClass=""
            input-classes="form-control-sm"
            inputStyle="height: 40px;"
            placeholder="Ex: 123" />
            <el-date-picker
              v-model="value.value"
              @input="$emit('changed', value)"
              v-if="value.type && value.type.value == 'date'"
              :clearable="false"
              format="d/MM/yyyy"
              type="date">
            </el-date-picker>
            <multiselect
              v-model="value.value"
              @input="$emit('changed', value)"
              v-if="value.type && value.type.value == 'current_user'"
              :options="userAttrs"
              placeholder="Ex: >="
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="translated_name"
              track-by="name"
              :show-labels="false"
              :allow-empty="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { Cascader, DatePicker } from "element-ui";

export default {
  components: {
    [Cascader.name]: Cascader,
    [DatePicker.name]: DatePicker,
    Multiselect,
  },
  props: {
    initialClass: {
      type: String,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectorProps: {
        lazy: true,
        parent: this,
        lazyLoad(node, resolve) {
          const klass = node.data ? node.data.class_name : this.parent.initialClass
          if(!klass) return
  
          this.parent.$http.secured
              .get('/api/v1/dashboards/classes/' + klass)
              .then(response => {
                const { data } = response
                var options = []
  
                data.associations.forEach(assoc => options.push({
                    value: assoc.association_name,
                    class_name: assoc.class_name,
                    label: assoc.translated_name,
                    leaf:  false
                  })
                );
  
                data.columns.forEach(col => options.push({
                    value: col.name,
                    label: col.translated_name,
                    type:  col.type,
                    leaf:  true
                  })
                );
  
                resolve(options);
              })
        },
      },
      options: [{
          value: 'guide',
          label: 'Guide',
          children: [{
            value: 'disciplines',
            label: 'Disciplines',
            children: [{
              value: 'consistency',
              label: 'Consistency',
            }]
          }],
        },
        {
          value: 'consistency',
          label: 'Consistency',
        }
      ],
      conditionals: [
        {
          name: '=',
          value: '$and',
        },
        {
          name: '≠',
          value: '$not',
        },
        {
          name: '>',
          value: '$gt',
        },
        {
          name: '>=',
          value: '$gte',
        },
        {
          name: '<',
          value: '$lt',
        },
        {
          name: '<=',
          value: '$lte',
        },
      ],
      valueOptions: [
        {name: 'Texto',          value: 'text'},
        {name: 'Número',         value: 'number'},
        {name: 'Dias Atrás',     value: 'days'},
        {name: 'Data',           value: 'date'},
        {name: 'Usuário Logado', value: 'current_user'},
      ],
      userAttrs: [],
    }
  },
  methods: {
    initUserAttrs() {
      this.$http.secured
          .get('/api/v1/dashboards/classes/user')
          .then(response => {
            this.userAttrs = response.data.columns
          })
    },
  },
  mounted() {
    this.initUserAttrs()
  }
}
</script>
